import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsHeroComponent } from '../../components/products/products-hero/products-hero.component';
import { ProductsOverviewComponent } from '../../components/products/products-overview/products-overview.component';
import { HowToApplyComponent } from '../../components/products/how-to-apply/how-to-apply.component';
import { ApplyBannerComponent } from '../../components/common/apply-banner/apply-banner.component';
import { ProductCardsComponent } from '../../components/products/product-cards/product-cards.component';
import { CTABannerComponent } from '../../components/common/cta-banner/cta-banner.component';
import { FloatingButtonsComponent } from '../../components/common/floating-buttons/floating-buttons.component';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-products-page',
  standalone: true,
  imports: [
    CommonModule,
    ProductsHeroComponent,
    ProductsOverviewComponent,
    HowToApplyComponent,
    ApplyBannerComponent,
    ProductCardsComponent,
    CTABannerComponent,
    FloatingButtonsComponent
  ],
  templateUrl: './products-page.component.html',
  styleUrls: ['./products-page.component.scss']
})
export class ProductsPageComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productsPage', { static: false }) productsPage?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track page view
    this.analyticsService.trackPageView('Productos', '/productos');
  }

  ngAfterViewInit() {
    // Registrar la página completa para tracking de analytics
    if (this.productsPage?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.productsPage.nativeElement,
        'Products Page',
        'products-page-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
